import { connect } from 'react-redux';
import { updateUserRegistrationForm, stepValidationStatusChanged } from '../actions';
import UserDetailsPageStep from '../components/UserDetailsPageStep';
import { getUserDetailsPageStep } from '../selectors';

const mapStateToProps = state => getUserDetailsPageStep(state);

const mapDispatchToProps = dispatch => ({
    onFieldsUpdated: fields => dispatch(updateUserRegistrationForm(fields)),
    onStepValidationStatusChanged: stepValidationStatus => dispatch(stepValidationStatusChanged(stepValidationStatus)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailsPageStep);
